"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.auditWithdrawApi = auditWithdrawApi;
exports.auditWithdrawAsyncApi = auditWithdrawAsyncApi;
exports.balanceApi = balanceApi;
exports.captchaApi = captchaApi;
exports.foundsApi = foundsApi;
exports.freezeBalanceApi = freezeBalanceApi;
exports.getInfo = getInfo;
exports.getIntegralRecordListApi = getIntegralRecordListApi;
exports.getLoginPicApi = getLoginPicApi;
exports.getWithdrawBatchTaskDetailApi = getWithdrawBatchTaskDetailApi;
exports.getWithdrawBatchTaskFailedDetailApi = getWithdrawBatchTaskFailedDetailApi;
exports.getWithdrawBatchTaskListApi = getWithdrawBatchTaskListApi;
exports.getWithdrawBatchTaskSuccessDetailApi = getWithdrawBatchTaskSuccessDetailApi;
exports.getWithdrawListApi = getWithdrawListApi;
exports.getWithdrawStatisticApi = getWithdrawStatisticApi;
exports.giftPaidMemberApi = giftPaidMemberApi;
exports.groupPiApi = groupPiApi;
exports.infobyconditionApi = infobyconditionApi;
exports.levelDeleteApi = levelDeleteApi;
exports.levelInfoApi = levelInfoApi;
exports.levelListApi = levelListApi;
exports.levelSaveApi = levelSaveApi;
exports.levelUpdateApi = levelUpdateApi;
exports.levelUseApi = levelUseApi;
exports.login = login;
exports.logout = logout;
exports.memberBenefitsEditApi = memberBenefitsEditApi;
exports.memberBenefitsListApi = memberBenefitsListApi;
exports.memberBenefitsStatementEditApi = memberBenefitsStatementEditApi;
exports.memberBenefitsStatementSwitchApi = memberBenefitsStatementSwitchApi;
exports.memberCardAddApi = memberCardAddApi;
exports.memberCardDeleteApi = memberCardDeleteApi;
exports.memberCardEditApi = memberCardEditApi;
exports.memberCardListApi = memberCardListApi;
exports.memberCardSwitchApi = memberCardSwitchApi;
exports.memberConfigEditApi = memberConfigEditApi;
exports.memberConfigGetApi = memberConfigGetApi;
exports.memberOrderInfoApi = memberOrderInfoApi;
exports.memberOrderListApi = memberOrderListApi;
exports.merchantLogin = merchantLogin;
exports.systemUserLevelConfigApi = systemUserLevelConfigApi;
exports.systemUserLevelRuleApi = systemUserLevelRuleApi;
exports.systemUserLevelUpdateConfigApi = systemUserLevelUpdateConfigApi;
exports.systemUserLevelUpdateRuleApi = systemUserLevelUpdateRuleApi;
exports.tagAllListApi = tagAllListApi;
exports.tagDeleteApi = tagDeleteApi;
exports.tagInfoApi = tagInfoApi;
exports.tagListApi = tagListApi;
exports.tagPiApi = tagPiApi;
exports.tagSaveApi = tagSaveApi;
exports.tagUpdateApi = tagUpdateApi;
exports.topdetailApi = topdetailApi;
exports.updatePhoneApi = updatePhoneApi;
exports.updateSpreadApi = updateSpreadApi;
exports.updateWithdrawCommentApi = updateWithdrawCommentApi;
exports.userDeleteApi = userDeleteApi;
exports.userDetailApi = userDetailApi;
exports.userInfoApi = userInfoApi;
exports.userLevelUpdateApi = userLevelUpdateApi;
exports.userListApi = userListApi;
exports.userUpdateApi = userUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function login(data) {
  return (0, _request.default)({
    url: 'admin/platform/login',
    method: 'post',
    data: data
  });
}
function getInfo() {
  return (0, _request.default)({
    url: 'admin/platform/getAdminInfoByToken',
    method: 'get'
  });
}
function logout() {
  return (0, _request.default)({
    url: 'admin/platform/logout',
    method: 'get'
  });
}

/**
 * 会员管理 列表
 * @param params
 */
function userListApi(params) {
  return (0, _request.default)({
    url: "admin/platform/user/list",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 修改
 * @param params
 * @param data
 */
function userUpdateApi(params, data) {
  return (0, _request.default)({
    url: "admin/platform/user/update",
    method: 'post',
    params: params,
    data: data
  });
}

/**
 * 会员管理等级 修改
 * @param data
 */
function userLevelUpdateApi(data) {
  return (0, _request.default)({
    url: "admin/user/update/level",
    method: 'post',
    data: data
  });
}

/**
 * 会员管理 详情
 * @param params
 */
function userInfoApi(params) {
  return (0, _request.default)({
    url: "admin/user/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 账户详情
 * @param params
 */
function infobyconditionApi(params) {
  return (0, _request.default)({
    url: "admin/user/infobycondition",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 账户详情top数据
 * @param params
 */
function topdetailApi(params) {
  return (0, _request.default)({
    url: "admin/user/topdetail",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 批量设置分组
 * @param params
 */
function groupPiApi(params) {
  return (0, _request.default)({
    url: "admin/user/group",
    method: 'post',
    params: params
  });
}

/**
 * 会员管理 批量设置标签
 * @param data
 */
function tagPiApi(data) {
  return (0, _request.default)({
    url: "admin/platform/user/tag",
    method: 'post',
    data: data
  });
}

/**
 * 会员管理 积分余额
 * @param params
 */
function foundsApi(params) {
  return (0, _request.default)({
    url: "admin/platform/user/operate/integer",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 积分余额
 * @param params
 */
function balanceApi(params) {
  return (0, _request.default)({
    url: "admin/platform/user/operate/balance",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 红包余额
 * @param params
 */
function freezeBalanceApi(params) {
  return (0, _request.default)({
    url: "admin/platform/user/operate/freeze",
    method: 'get',
    params: params
  });
}

/**
 * 会员管理 删除
 * @param params
 */
function userDeleteApi(params) {
  return (0, _request.default)({
    url: "admin/user/delete",
    method: 'get',
    params: params
  });
}

/**
 * 会员等级 列表
 */
function levelListApi() {
  return (0, _request.default)({
    url: "admin/platform/system/user/level/list",
    method: 'get'
  });
}

/**
 * 会员等级 新增
 * @param data
 */
function levelSaveApi(data) {
  return (0, _request.default)({
    url: "admin/platform/system/user/level/save",
    method: 'post',
    data: data
  });
}

/**
 * 会员等级 编辑
 *  @param data
 */
function levelUpdateApi(data) {
  return (0, _request.default)({
    url: "admin/platform/system/user/level/update",
    method: 'post',
    data: data
  });
}

/**
 * 会员等级 详情
 * @param params
 */
function levelInfoApi(params) {
  return (0, _request.default)({
    url: "admin/system/user/level/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员等级 删除
 * @param id
 */
function levelDeleteApi(id) {
  return (0, _request.default)({
    url: "admin/platform/system/user/level/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 会员等级 是否显示
 * @param data
 */
function levelUseApi(data) {
  return (0, _request.default)({
    url: "admin/platform/system/user/level/use",
    method: 'post',
    data: data
  });
}

/**
 * 会员标签 列表
 * @param params
 */
function tagListApi(params) {
  return (0, _request.default)({
    url: "admin/platform/user/tag/list",
    method: 'get',
    params: params
  });
}

/**
 * 会员标签 新增
 * @param data
 */
function tagSaveApi(data) {
  return (0, _request.default)({
    url: "admin/platform/user/tag/save",
    method: 'post',
    data: data
  });
}

/**
 * 会员标签 编辑
 * @param data
 */
function tagUpdateApi(data) {
  return (0, _request.default)({
    url: "admin/platform/user/tag/update",
    method: 'post',
    data: data
  });
}

/**
 * 会员标签 详情
 * @param params
 */
function tagInfoApi(params) {
  return (0, _request.default)({
    url: "admin/user/tag/info",
    method: 'get',
    params: params
  });
}

/**
 * 会员标签 删除
 * @param id
 */
function tagDeleteApi(id) {
  return (0, _request.default)({
    url: "admin/platform/user/tag/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 用户标签全部列表
 */
function tagAllListApi(id) {
  return (0, _request.default)({
    url: "admin/platform/user/tag/all/list",
    method: 'get'
  });
}

/**
 *获取登录页图片
 */
function getLoginPicApi() {
  return (0, _request.default)({
    url: "admin/platform/getLoginPic",
    method: 'get'
  });
}

/**
 * @description 验证码
 */
function captchaApi() {
  return (0, _request.default)({
    url: "/publicly/validate/code/get",
    method: 'get'
  });
}

/**
 * @description 修改上级推广人
 */
function updateSpreadApi(data) {
  return (0, _request.default)({
    url: "admin/platform/retail/store/update/user/spread",
    method: 'post',
    data: data
  });
}

/**
 * @description 修改手机号
 */
function updatePhoneApi(params) {
  return (0, _request.default)({
    url: "admin/user/update/phone",
    method: 'get',
    params: params
  });
}

/**
 * @description 用户详情列表
 */
function userDetailApi(id) {
  return (0, _request.default)({
    url: "admin/platform/user/detail/".concat(id),
    method: 'get'
  });
}

/**
 * @description 获取用户等级配置
 */
function systemUserLevelConfigApi(id) {
  return (0, _request.default)({
    url: "admin/platform/system/user/level/get/config",
    method: 'GET'
  });
}

/**
 * @description 编辑用户等级配置
 */
function systemUserLevelUpdateConfigApi(data) {
  return (0, _request.default)({
    url: "admin/platform/system/user/level/update/config",
    method: 'POST',
    data: data
  });
}

/**
 * @description 获取用户等级规则
 */
function systemUserLevelRuleApi(id) {
  return (0, _request.default)({
    url: "admin/platform/system/user/level/get/rule",
    method: 'GET'
  });
}

/**
 * @description 编辑用户等级规则
 */
function systemUserLevelUpdateRuleApi(data) {
  return (0, _request.default)({
    url: "admin/platform/system/user/level/update/rule",
    method: 'POST',
    data: data
  });
}

/**
 * @description 编辑付费会员基础配置
 */
function memberConfigEditApi(data) {
  return (0, _request.default)({
    url: "admin/platform/paid/member/base/config/edit",
    method: 'POST',
    data: data
  });
}

/**
 * @description 付费会员基础配置信息获取
 */
function memberConfigGetApi() {
  return (0, _request.default)({
    url: "admin/platform/paid/member/base/config/get",
    method: 'get'
  });
}

/**
 * @description 编辑付费会员会员权益
 */
function memberBenefitsEditApi(data) {
  return (0, _request.default)({
    url: "admin/platform/paid/member/benefits/edit",
    method: 'post',
    data: data
  });
}

/**
 * @description 获取付费会员会员权益
 */
function memberBenefitsListApi() {
  return (0, _request.default)({
    url: "admin/platform/paid/member/benefits/list",
    method: 'get'
  });
}

/**
 * @description 编辑付费会员会员权益说明
 */
function memberBenefitsStatementEditApi(data) {
  return (0, _request.default)({
    url: "admin/platform/paid/member/benefits/statement/edit",
    method: 'post',
    data: data
  });
}

/**
 * @description 付费会员会员权益开关
 */
function memberBenefitsStatementSwitchApi(id) {
  return (0, _request.default)({
    url: "admin/platform/paid/member/benefits/switch/".concat(id),
    method: 'post'
  });
}

/**
 * @description 添加付费会员卡
 */
function memberCardAddApi(data) {
  return (0, _request.default)({
    url: "admin/platform/paid/member/card/add",
    method: 'post',
    data: data
  });
}

/**
 * @description 删除付费会员卡
 */
function memberCardDeleteApi(id) {
  return (0, _request.default)({
    url: "admin/platform/paid/member/card/delete/".concat(id),
    method: 'post'
  });
}

/**
 * @description 编辑付费会员卡
 */
function memberCardEditApi(data) {
  return (0, _request.default)({
    url: "admin/platform/paid/member/card/edit",
    method: 'post',
    data: data
  });
}

/**
 * @description 付费会员卡开关
 */
function memberCardSwitchApi(id) {
  return (0, _request.default)({
    url: "admin/platform/paid/member/card/switch/".concat(id),
    method: 'post'
  });
}

/**
 * @description 付费会员卡列表
 */
function memberCardListApi(params) {
  return (0, _request.default)({
    url: "admin/platform/paid/member/list",
    method: 'get',
    params: params
  });
}

/**
 * @description 付费会员订单详情
 */
function memberOrderInfoApi(orderNo) {
  return (0, _request.default)({
    url: "admin/platform/paid/member/order/info/".concat(orderNo),
    method: 'get'
  });
}

/**
 * @description 付费会员订单分页列表
 */
function memberOrderListApi(params) {
  return (0, _request.default)({
    url: "admin/platform/paid/member/order/page/list",
    method: 'get',
    params: params
  });
}

/**
 * @description 赠送用户付费会员
 */
function giftPaidMemberApi(data) {
  return (0, _request.default)({
    url: "admin/platform/user/gift/paid/member",
    method: 'post',
    data: data
  });
}

/**
 * @description 越权登录商户
 */
function merchantLogin(id) {
  return (0, _request.default)({
    url: "admin/platform/merchant/ultra/vires/login/".concat(id),
    method: 'post'
  });
}

/**
 * 用户积分记录明细
 * @param params
 */
function getIntegralRecordListApi(params) {
  return (0, _request.default)({
    url: 'admin/platform/integral/record/detail/list',
    method: 'GET',
    params: params
  });
}

/**
 * @description 获取提现列表
 */
function getWithdrawListApi(params) {
  return (0, _request.default)({
    url: "admin/platform/wallet/withdraw/list",
    method: 'GET',
    params: params
  });
}

/**
 * 即抽即开记录统计
 * @param params
 */
function getWithdrawStatisticApi(params) {
  return (0, _request.default)({
    url: 'admin/platform/wallet/withdraw/total',
    method: 'GET',
    params: params
  });
}

/**
 * @description 审核提现
 */
function auditWithdrawApi(data) {
  return (0, _request.default)({
    url: "admin/platform/wallet/withdraw/audit",
    method: 'POST',
    data: data
  });
}

/**
 * @description 异步审核提现
 */
function auditWithdrawAsyncApi(data) {
  return (0, _request.default)({
    url: "admin/platform/wallet/withdraw/auditAsync",
    method: 'POST',
    data: data
  });
}

/**
 * @description 审核备注
 */
function updateWithdrawCommentApi(data) {
  return (0, _request.default)({
    url: "admin/platform/wallet/withdraw/remark",
    method: 'POST',
    data: data
  });
}

/**
 * @description 获取批量提现审核任务列表
 */
function getWithdrawBatchTaskListApi(params) {
  return (0, _request.default)({
    url: "admin/platform/wallet/withdraw/batchTask/list",
    method: 'GET',
    params: params
  });
}

/**
 * @description 获取批量提现审核任务明细列表
 */
function getWithdrawBatchTaskDetailApi(params) {
  return (0, _request.default)({
    url: "admin/platform/wallet/withdraw/batchTask/detail/list",
    method: 'GET',
    params: params
  });
}

/**
 * @description 获取批量提现审核任务成功明细列表
 */
function getWithdrawBatchTaskSuccessDetailApi(params) {
  return (0, _request.default)({
    url: "admin/platform/wallet/withdraw/batchTask/detail/success",
    method: 'GET',
    params: params
  });
}

/**
 * @description 获取批量提现审核任务失败明细列表
 */
function getWithdrawBatchTaskFailedDetailApi(params) {
  return (0, _request.default)({
    url: "admin/platform/wallet/withdraw/batchTask/detail/failed",
    method: 'GET',
    params: params
  });
}